import { api } from "api";

/**
 * The commission rate that applies when a row carries none of its own.
 *
 * THE DASHBOARD OWNS NO DEFAULT. It used to hold 15 for drivers and 5 for
 * restaurants in `utils/percentage.js`, and the API and the driver app each
 * held a copy too. The list payloads now carry `effective_*` per row, and this
 * answers the one case they cannot: the settlement card before a restaurant or
 * a driver is picked.
 *
 * @param {number|string|undefined} cityId Optional. The city's own defaults.
 * @returns {Promise<{driver: number, vendor: number, source: string}>}
 */
export const getCommissionDefaults = async (cityId) => {
    const response = await api.get("api/commission-defaults", {
        params: cityId ? { cityId } : undefined,
    });

    return response.data;
};
